// Vendor's view of a PO line item's units

export default angular
  .module('filters.displayOrderUnit', [])

  .filter(
    'displayOrderUnit',
    () =>
      function(catalogProductOrLineItem) {
        if (catalogProductOrLineItem == null) {
          return;
        }
        const simplifiedUnits =
          catalogProductOrLineItem.unitQuantity === 1
            ? catalogProductOrLineItem.unitLabel
            : `${catalogProductOrLineItem.unitQuantity} ${catalogProductOrLineItem.unitLabel}`;

        if (catalogProductOrLineItem.unitQuantityLabel != null) {
          return `${catalogProductOrLineItem.unitQuantityLabel} (${simplifiedUnits})`;
        }
        return simplifiedUnits;
      },
  );
